import React, { useState } from 'react';
import './Help.css';

function Help() {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="page-container help-page" style={{paddingTop: '60px'}}>
      <div className="help-header">
        <img src="/logo.svg" className="help-logo" alt="Zhaga VPN" />
        <h1 className="page-title">Добро пожаловать в Zhaga VPN</h1>
      </div>
      
      <div className="help-intro-section">
        <h2>📱 О приложении</h2>
        <p>Zhaga VPN — это сервис для приобретения защищённых VPN-ключей стандарта VLESS. Мы предоставляем быстрый и безопасный доступ к интернету через современные протоколы шифрования.</p>
        
        <h2>🚀 Как начать работу</h2>
        <ol className="instruction-list">
          <li><strong>Выберите тариф</strong> — перейдите в раздел "Подписки" и выберите подходящий план</li>
          <li><strong>Оплатите подписку</strong> — используйте банковскую карту, СберПэй или СБП</li>
          <li><strong>Получите ключ</strong> — после оплаты ключ появится в разделе "Кабинет"</li>
          <li><strong>Скачайте приложение</strong> — перейдите в "Скачать" и установите V2RayTun для вашего устройства</li>
          <li><strong>Подключитесь</strong> — скопируйте ключ из кабинета и добавьте его в приложение</li>
      </ol>
      
        <h2>💡 Поддержка</h2>
        <p>Если у вас возникли вопросы, обратитесь в нашу службу поддержки через раздел "Поддержка" или напишите на <a href="mailto:ratstories@yandex.ru">ratstories@yandex.ru</a></p>
      </div>
      
      <h2 className="documents-title">📄 Юридические документы</h2>
      
      <div className="accordion">
        <div className="accordion-item">
          <button 
            className={`accordion-header ${openSection === 'privacy' ? 'active' : ''}`}
            onClick={() => toggleSection('privacy')}
          >
            <span>Политика в отношении обработки персональных данных</span>
            <span className="accordion-icon">{openSection === 'privacy' ? '−' : '+'}</span>
          </button>
          {openSection === 'privacy' && (
            <div className="accordion-content">
              <div className="document-date">Дата обновления: 8 октября 2025 года</div>
              
              <h3>1. Общие положения</h3>
              <p>
1.1. Настоящая политика обработки персональных данных (далее — Политика) составлена в соответствии с требованиями Федерального закона РФ от 27.07.2006 №152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению их безопасности, предпринимаемые владельцем Telegram-бота https://t.me/zhagavpn_bot, в дальнейшем именуемым Оператором.<br/><br/>

1.2. Оператор ставит своей основной целью обеспечение защиты прав и свобод человека и гражданина при обработке персональных данных, включая защиту прав на неприкосновенность частной жизни, личную и семейную тайну.<br/><br/>

1.3. Настоящая Политика применяется ко всей информации, которую Оператор может получить о пользователях Telegram-бота https://t.me/zhagavpn_bot или иных сервисов под брендом Zhaga VPN.
</p>

              <h3>2. Основные понятия, используемые в Политике</h3>
              <p>
2.1. Автоматизированная обработка персональных данных — обработка персональных данных с использованием вычислительной техники.

2.2. Блокирование персональных данных — временное прекращение обработки персональных данных.

2.3. Телеграм-бот — совокупность программ, данных и материалов, доступных по адресу https://t.me/zhagavpn_bot.

2.4. Информационная система персональных данных — совокупность баз данных и технологий, обеспечивающих обработку персональных данных.

2.5. Обезличивание персональных данных — действия, исключающие возможность определить, кому принадлежат данные.

2.6. Обработка персональных данных — любые действия с персональными данными, включая сбор, хранение, передачу, использование и уничтожение.

2.7. Оператор — лицо, самостоятельно или совместно с другими организующее обработку персональных данных.

2.8. Персональные данные — любая информация, относящаяся прямо или косвенно к пользователю Telegram-бота https://t.me/zhagavpn_bot.

2.9. Пользователь — любое физическое лицо, использующее Telegram-бот Zhaga VPN.

2.10. Распространение персональных данных — действия, направленные на раскрытие данных неопределённому кругу лиц.

2.11. Уничтожение персональных данных — действия, в результате которых данные удаляются без возможности восстановления.
              </p>

              <h3>3. Права и обязанности Оператора</h3>
              <p>
<strong>Оператор имеет право:</strong>

• получать от пользователя достоверную информацию, необходимую для оказания услуг;
• продолжать обработку персональных данных без согласия субъекта в случаях, предусмотренных законом;
• самостоятельно определять меры защиты данных.

<strong>Оператор обязан:</strong>

• обеспечивать конфиденциальность и безопасность персональных данных;
• предоставлять пользователю информацию о его данных по запросу;
• отвечать на запросы пользователей в установленные законом сроки;
• публиковать актуальную версию Политики в свободном доступе;
• прекращать обработку и уничтожать персональные данные по завершении целей их обработки или по требованию пользователя.
              </p>

              <h3>4. Права и обязанности субъектов персональных данных</h3>
              <p>
<strong>Пользователь имеет право:</strong>

• получать информацию об обработке своих данных;
• требовать уточнения, блокировки или уничтожения данных;
• отозвать согласие на обработку данных;
• обжаловать действия Оператора в уполномоченные органы или суд;
• отказаться от получения рассылок и уведомлений.

<strong>Пользователь обязан:</strong>

• предоставлять Оператору достоверные данные;
• своевременно уведомлять об их изменении.
              </p>

              <h3>5. Персональные данные, обрабатываемые Оператором</h3>
              <p>
Оператор может обрабатывать следующие данные:

• адрес электронной почты;
• IP-адрес;
• технические данные соединения (тип устройства, страна, время подключения);
• обезличенные данные (cookie-файлы, метаданные телеграм-аккаунта).

Оператор не обрабатывает специальные категории персональных данных (о расовой принадлежности, политических взглядах, религиозных убеждениях и т.п.).
              </p>

              <h3>6. Принципы обработки персональных данных</h3>
              <p>
• Обработка данных осуществляется на законной и справедливой основе.
• Сбор данных ограничен конкретными целями.
• Не допускается избыточность данных.
• Данные должны быть точными и актуальными.
• Срок хранения данных ограничен целями их обработки.
• После достижения целей обработки данные подлежат уничтожению или обезличиванию.
              </p>

              <h3>7. Цели обработки персональных данных</h3>
              <p>
Персональные данные пользователей обрабатываются с целью:

• регистрации и идентификации пользователя в системе Zhaga VPN;
• заключения и исполнения договоров на оказание услуг;
• направления уведомлений о статусе услуг и оплатах;
• предоставления доступа к сервису;
• информирования о новых функциях, акциях и обновлениях (при наличии согласия пользователя).

Пользователь может в любое время отказаться от рассылок, направив письмо на support@zhagavpn.ru с темой «Отказ от уведомлений».
              </p>

              <h3>8. Правовые основания обработки персональных данных</h3>
              <p>
• Федеральный закон №152-ФЗ «О персональных данных»;
• Гражданский кодекс РФ;
• Согласие пользователя на обработку персональных данных;
• Договоры и иные соглашения между пользователем и Оператором.
              </p>

              <h3>9. Условия обработки персональных данных</h3>
              <p>
• Обработка осуществляется с согласия пользователя, за исключением случаев, предусмотренных законом.
• Срок хранения данных определяется целями обработки и не превышает необходимого периода.
• Пользователь может в любое время отозвать согласие, направив уведомление на ratstories@yandex.ru с пометкой «Отзыв согласия на обработку персональных данных».
• Передача данных третьим лицам возможна только при исполнении закона или договора с пользователем.
              </p>

              <h3>10. Меры по защите персональных данных</h3>
              <p>
Оператор принимает все необходимые правовые, организационные и технические меры для защиты персональных данных от:

• неправомерного доступа;
• уничтожения или изменения;
• блокировки, копирования или распространения;
• иных неправомерных действий.

Хранение персональных данных осуществляется на защищённых серверах с ограниченным доступом.
              </p>

              <h3>11. Трансграничная передача персональных данных</h3>
              <p>
Передача персональных данных на территорию иностранных государств допускается только при условии обеспечения ими надлежащей защиты прав субъектов персональных данных либо при наличии письменного согласия пользователя.
              </p>

              <h3>12. Конфиденциальность персональных данных</h3>
              <p>
Оператор и лица, получившие доступ к персональным данным, обязаны не раскрывать их третьим лицам без согласия пользователя, если иное не установлено законом.
              </p>

              <h3>13. Заключительные положения</h3>
              <p>
13.1. Пользователь может получить разъяснения по вопросам обработки персональных данных, обратившись на электронную почту: ratstories@yandex.ru.

13.2. В Политику могут вноситься изменения. Новая редакция вступает в силу с момента её публикации в Telegram-боте https://t.me/zhagavpn_bot.

13.3. Актуальная версия Политики всегда доступна в открытом доступе в Telegram-боте и на официальных ресурсах Zhaga VPN.
              </p>
            </div>
          )}
        </div>

        <div className="accordion-item">
          <button 
            className={`accordion-header ${openSection === 'agreement' ? 'active' : ''}`}
            onClick={() => toggleSection('agreement')}
          >
            <span>Соглашение о присоединении к рекуррентной системе платежей</span>
            <span className="accordion-icon">{openSection === 'agreement' ? '−' : '+'}</span>
          </button>
          {openSection === 'agreement' && (
            <div className="accordion-content">
              <div className="document-date">Дата обновления: 8 октября 2025 года</div>
              
              <p>
Настоящее Соглашение (далее – «Соглашение») заключается между владельцем Telegram-бота https://t.me/zhagavpn_bot (далее – «Исполнитель») и любым дееспособным физическим лицом (далее – «Клиент»), заключающим публичную оферту (далее – «Договор») посредством использования Telegram-бота Исполнителя.

Клиент выражает намерение использовать сервис автоматической уплаты очередных платежей по Договору банковской картой путём автоматического списания денежных средств с банковской карты Клиента, указанной при оплате.

Оформление Заказа и нажатие кнопки «Оплатить» означает полное и безоговорочное согласие Клиента со всеми условиями настоящего Соглашения.

Настоящее Соглашение является договором присоединения по смыслу статьи 428 Гражданского кодекса Российской Федерации.
              </p>

              <h3>1. Термины и определения</h3>
              <p>
1.1. Соглашение — настоящий документ, опубликованный в Telegram-боте https://t.me/zhagavpn_bot и/или на сайте https://telegra.ph.

1.2. Клиент — полностью дееспособное физическое лицо, заключившее с Исполнителем публичную оферту (Договор).

1.3. Телеграм-бот — ресурс, содержащий актуальную информацию об Услугах Исполнителя, размещённый по адресу https://t.me/zhagavpn_bot.

1.4. Договор — публичная оферта, размещённая в Telegram-боте.

1.5. Сервис «Рекуррентный платёж» — сервис, позволяющий Исполнителю автоматически получать оплату Услуг по Договору с банковской карты Клиента.

1.6. Банк — кредитная организация, осуществляющая выпуск банковских карт и операции с ними в соответствии с законодательством Российской Федерации.

1.7. Банковская карта — расчётная или кредитная карта, выпущенная Банком и используемая Клиентом для оплаты Услуг Исполнителя через систему ЮKassa (ООО НКО «ЮМани»).

1.8. Процессинговый центр — автоматизированная система обработки транзакций, обеспечивающая проведение платежей между Банком и ЮKassa.

1.9. Персональные данные — любая информация, относящаяся прямо или косвенно к Клиенту.
              </p>

              <h3>2. Предмет Соглашения</h3>
              <p>
2.1. Сервис «Рекуррентный платёж» позволяет Клиенту производить оплату Услуг Исполнителя по Договору путем автоматического списания денежных средств с банковской карты Клиента в пользу Исполнителя.

2.2. После подключения Сервиса с банковской карты Клиента будут производиться автоматические переводы в размерах, необходимых для исполнения обязательств Клиента по Договору.

2.3. Все расчёты осуществляются в рублях РФ.

2.4. Дополнительная плата за использование Сервиса не взимается.

2.5. Активация Сервиса происходит следующим образом:
• Клиент оформляет подписку на Услуги в Telegram-боте https://t.me/zhagavpn_bot;
• нажимает кнопку «Оплатить», подтверждая согласие с условиями Договора и настоящего Соглашения;
• после чего перенаправляется на платёжную страницу ЮKassa (https://yookassa.ru), где вводит данные банковской карты;
• после успешной оплаты Услуг и подтверждения согласия с Соглашением сервис считается активированным.

2.6. Совершение указанных действий означает согласие Клиента на использование рекуррентных платежей и передачу идентифицирующих данных в ЮKassa для их обработки в целях исполнения Договора.
              </p>

              <h3>3. Порядок использования Сервиса</h3>
              <p>
3.1. После активации Сервиса автоматическое списание средств производится не ранее чем за 3 дня и не позднее чем за 15 минут до окончания оплаченного периода.

3.2. Списание денежных средств выполняется Банком-эмитентом через процессинг ЮKassa.

3.3. Исполнитель не хранит и не обрабатывает данные банковских карт Клиента. Все операции выполняются исключительно через защищённые платёжные шлюзы ЮKassa.

3.4. Исполнитель не гарантирует возможность проведения операции по конкретной карте; решение о платеже принимает Банк.

3.5. Клиент подтверждает, что является держателем карты и вводит её данные корректно и добровольно.

3.6. Подключение Сервиса возможно только при наличии технической возможности на стороне ЮKassa и Банка. Исполнитель не несёт ответственности за сбои на стороне платёжных систем.

3.7. Отключение (отказ) от рекуррентных платежей производится:
• в Telegram-боте https://t.me/zhagavpn_bot;
• либо по запросу на электронную почту: ratstories@yandex.ru

Отключение производится в течение 48 часов с момента получения запроса.

3.8. В случае недостатка средств на карте Исполнитель вправе повторно направлять запросы на списание до успешного проведения операции.
              </p>

              <h3>4. Права и обязанности сторон</h3>
              <p>
4.1. Исполнитель вправе отказать Клиенту в активации Сервиса без объяснения причин.

4.2. Исполнитель вправе изменять настоящее Соглашение в одностороннем порядке. Изменения вступают в силу с момента публикации новой редакции в Telegram-боте. В случае несогласия Клиент вправе отказаться от Сервиса.

4.3. Исполнитель не несёт ответственности за временную недоступность Сервиса по причинам, не зависящим от него.

4.4. В случае утраты или замены карты Клиент обязан уведомить Исполнителя на support@zhagavpn.ru в течение 3 (трёх) дней.

4.5. Клиент обязуется использовать только банковскую карту, владельцем которой является. При использовании чужой карты Клиент несёт личную ответственность за возможный ущерб.

4.6. Исполнитель вправе прекратить использование Сервиса при невозможности списания средств с карты Клиента.

4.7. Стороны освобождаются от ответственности за неисполнение обязательств в случае обстоятельств непреодолимой силы (форс-мажора), при условии своевременного уведомления другой стороны.
              </p>

              <h3>5. Срок действия и порядок урегулирования споров</h3>
              <p>
5.1. Соглашение вступает в силу с момента его акцепта Клиентом и действует на срок действия Договора.

5.2. При отсутствии заявлений о расторжении, Соглашение автоматически продлевается на тот же срок.

5.3. Исполнитель вправе расторгнуть Соглашение в одностороннем порядке, уведомив Клиента не менее чем за 5 (пять) календарных дней.

5.4. Споры решаются путём переговоров и обмена письменными претензиями.

5.5. В случае невозможности урегулирования спора мирным путём, он подлежит рассмотрению в Арбитражном суде города Москвы.
              </p>

              <h3>6. Реквизиты</h3>
              <p>
6.1. Реквизиты Клиента указываются им при оформлении заказа в Telegram-боте.

6.2. В случае изменения реквизитов Клиент уведомляет Исполнителя по адресу ratstories@yandex.ru
              </p>
            </div>
          )}
        </div>

        <div className="accordion-item">
          <button 
            className={`accordion-header ${openSection === 'contract' ? 'active' : ''}`}
            onClick={() => toggleSection('contract')}
          >
            <span>ДОГОВОР-ОФЕРТА НА ОКАЗАНИЕ УСЛУГ</span>
            <span className="accordion-icon">{openSection === 'contract' ? '−' : '+'}</span>
          </button>
          {openSection === 'contract' && (
            <div className="accordion-content">
              <div className="document-date">Дата публикации: 8 октября 2025 года</div>
              
              <p>
Настоящая Оферта от владельца телеграм-бота https://t.me/zhagavpn_bot, в дальнейшем именуемого «Продавец», адресована пользователю услуг телеграм-бота, в дальнейшем именуемому «Заказчик», и является предложением заключить договор оказания услуг (далее — «Договор») на условиях, изложенных ниже.

Акцептом настоящей Оферты (оплатой услуг) Заказчик подтверждает согласие со всеми её условиями.
              </p>

              <h3>1. Определения терминов</h3>
              <p>
1.1. Публичная оферта (Оферта) — публичное предложение Продавца, адресованное неопределённому кругу лиц, заключить договор оказания услуг дистанционным способом на условиях, содержащихся в настоящей Оферте, включая все приложения.

1.2. Заказ — решение Заказчика заказать услуги обработки данных и частного виртуального доступа через телеграм-бот https://t.me/zhagavpn_bot посредством выбора одного из тарифов и его оплаты. Оплата Заказа является полным и безоговорочным акцептом настоящей Оферты.

1.3. Продавец предоставляет услуги обработки данных, а также услуги частного виртуального доступа к сети Интернет (далее — «Услуги»), включая, но не ограничиваясь, услуги VPN, дополнительные программные решения, приложения, информационные материалы и другие инструменты, направленные на обеспечение конфиденциальности и безопасности в сети Интернет.

1.4. Тарифы — система цен за предоставляемые Услуги, опубликованная в телеграм-боте https://t.me/zhagavpn_bot.
              </p>

              <h3>2. Общие положения</h3>
              <p>
2.1. Заказ Услуг осуществляется через телеграм-бот https://t.me/zhagavpn_bot путём выбора тарифного плана и его оплаты. Оплата является подтверждением заключения настоящего Договора.

2.2. Акцептируя настоящую Оферту, Заказчик подтверждает, что:
а) полностью ознакомлен и согласен с условиями настоящего Договора;
б) предоставляет согласие на сбор, обработку и передачу персональных данных в соответствии с Политикой конфиденциальности, размещённой в телеграм-боте https://t.me/zhagavpn_bot.
              </p>

              <h3>3. Цена и порядок расчётов</h3>
              <p>
3.1. Стоимость Услуг указана в телеграм-боте https://t.me/zhagavpn_bot в разделе «Тарифы».

3.2. Продавец вправе в одностороннем порядке изменять стоимость Услуг.

3.3. Изменение цены не распространяется на уже оплаченные Заказы.

3.4. Обязательства по оплате считаются исполненными с момента поступления денежных средств Продавцу в полном объёме.

3.5. Оплата осуществляется способами, указанными в телеграм-боте https://t.me/zhagavpn_bot.
              </p>

              <h3>4. Оформление Заказа</h3>
              <p>
4.1. Заказ осуществляется через телеграм-бот https://t.me/zhagavpn_bot либо посредством выставления счёта на e-mail клиента.

4.2. При оформлении Заказа Заказчик обязан указать действующий адрес электронной почты.

4.3. Продавец вправе запросить дополнительную информацию для корректного оказания услуг. В случае отказа Заказчика предоставить запрашиваемые данные, Продавец не несёт ответственности за качество оказанных услуг.

4.4. Заказчик несёт ответственность за достоверность предоставленных данных.

4.5. Договор считается заключённым с момента оформления и оплаты Заказа в телеграм-боте https://t.me/zhagavpn_bot.

4.6. Если Заказчик не использовал функцию «Отмена подписки» в телеграм-боте, действие подписки продлевается автоматически на аналогичный срок по актуальной цене Тарифа (автопродление).
              </p>

              <h3>5. Порядок оказания Услуг</h3>
              <p>
5.1. Услуги оказываются в соответствии с описанием, размещённым в телеграм-боте https://t.me/zhagavpn_bot.
              </p>

              <h3>6. Прекращение оказания Услуг</h3>
              <p>
6.1. Заказчик вправе отказаться от Услуг в любое время, однако уплаченные денежные средства возврату не подлежат.

6.2. Договор считается действующим до момента письменного уведомления Продавца через контакты, указанные в телеграм-боте.

6.3. Продавец вправе приостановить или прекратить предоставление Услуг в случаях:

а) нарушения Заказчиком законодательства Российской Федерации или иных стран;
б) передачи личных данных доступа третьим лицам (за исключением близких родственников Заказчика);
в) превышения лимита трафика в размере 500 ГБ за 30 дней.

При превышении лимита доступ автоматически приостанавливается.
              </p>
            </div>
          )}
        </div>
      </div>
      
      <p className="footer-text">Спасибо, что используете наш сервис! 😊</p>
    </div>
  );
}

export default Help; 
